import { Component, Input, OnInit, EventEmitter, Output } from "@angular/core";
import { UntypedFormBuilder, Validators } from "@angular/forms";
import { DataProvider } from "projects/packcert-web/src/app/providers/data.provider";
import { SpinnerService } from 'shared-components';
import { CultivosService } from "../../../../../services/cultivos.service";
import { SessionContextService } from "projects/packcert-web/src/app/context/session-context.service";

@Component({
    selector: 'app-cultivo-catastro-new-edit',
    templateUrl: './new-edit.component.html'
})
export class CCaNewEditComponent implements OnInit {

    public newEditForm;
    public showError: boolean;
    public disable = false;

    public _toDelete: any;
    public _editable: boolean;

    @Input() _cultivoId;
    @Input() _cultivoCatastro;
    private _catastroId;

    public deleteModal = false;

    get editable(): boolean { return this._editable; }
    @Input() set editable(value: boolean) {
        this._editable = value;
        if (this.newEditForm) {
            if (value) {
                this.newEditForm.get('poligonoCatastral').enable();
                this.newEditForm.get('parcelaCatastral').enable();
                this.newEditForm.get('refCatastral').enable();
            } else {
                this.newEditForm.disable();
                this.newEditForm.patchValue({
                    poligonoCatastral: this.cultivoCatastro ? this.cultivoCatastro.poligonoCatastro : '',
                    parcelaCatastral: this.cultivoCatastro ? this.cultivoCatastro.parcelaCatastro : '',
                    refCatastral: this.cultivoCatastro ? this.cultivoCatastro.refCatastral : '',
                });
            }
        }
    }
    @Input() cultivoCatastro?;
    @Input() cultivoId;
    @Input() campanyaHabilitada;

    @Output() refresh = new EventEmitter<boolean>();
    @Output() pushMessage = new EventEmitter<string>();
    @Output() editableChanged = new EventEmitter<any>();
    @Output() close = new EventEmitter<boolean>();

    constructor(
        private _fb: UntypedFormBuilder,
        private readonly _spinnerService: SpinnerService,
        private readonly _dataProvider: DataProvider,
        private readonly _cultivosService: CultivosService,
        private readonly _sessionContext: SessionContextService

    ) {}

    ngOnInit() {
        this.newEditForm = this._fb.group({
            poligonoCatastral: ['', Validators.required],
            parcelaCatastral: ['', Validators.required],
            refCatastral: [''],
        });

        if (this.cultivoCatastro) {
            this.newEditForm.disable();
            this.newEditForm.patchValue({
                poligonoCatastral: this.cultivoCatastro ? this.cultivoCatastro.poligonoCatastro : '',
                parcelaCatastral: this.cultivoCatastro ? this.cultivoCatastro.parcelaCatastro : '',
                refCatastral: this.cultivoCatastro ? this.cultivoCatastro.refCatastral : ''
            });
            this._catastroId = this.cultivoCatastro ? this.cultivoCatastro.id : null;
        } else {
            this.newEditForm.get('poligonoCatastral').enable();
            this.newEditForm.get('parcelaCatastral').enable();
            this.newEditForm.get('refCatastral').enable();
        }
    }

    public get role() {
        return this._sessionContext.sessionUser.role;
    }

    public get claims() {
        return this._sessionContext.sessionUser.lsClaimTypes;
    }

    public save() {
        this.checkForm();
        if (this.newEditForm.valid && !this.cultivoCatastro) {
            this.cultivoCatastro = {
                cultivoId: this.cultivoId,
                poligonoCatastro: this.newEditForm.get('poligonoCatastral').value ? ('000' + this.newEditForm.get('poligonoCatastral').value).slice(-3) : "",
                parcelaCatastro: this.newEditForm.get('parcelaCatastral').value ? ('00000' + this.newEditForm.get('parcelaCatastral').value).slice(-5) : "",
                refCatastral: this.newEditForm.get('refCatastral').value ? this.newEditForm.get('refCatastral').value : "",
            };
            this._spinnerService.showSpinner();
            this._cultivosService.createCultivoCatastro(this.cultivoCatastro).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then((resp) => {
                if (resp) {
                    this._editable = false;
                    this.refresh.emit(true);
                    this.newEditForm.disable();
                    this.pushMessage.emit('global.success.itemCreated');
                } else {
                    this.showError = true;
                }
            },
            (error) => {
                this.showError = true;
                this.pushMessage.emit('global.error.noResponse');
            });
        } else if (this.newEditForm.valid && this.cultivoCatastro) {
            this.cultivoCatastro = {
                id: this.cultivoCatastro.id,
                cultivoId: this.cultivoId,
                poligonoCatastro: this.newEditForm.get('poligonoCatastral').value ? ('000' + this.newEditForm.get('poligonoCatastral').value).slice(-3) : "",
                parcelaCatastro: this.newEditForm.get('parcelaCatastral').value ? ('00000' + this.newEditForm.get('parcelaCatastral').value).slice(-5) : "",
                refCatastral: this.newEditForm.get('refCatastral').value ? this.newEditForm.get('refCatastral').value : "",
            };
            this._spinnerService.showSpinner();
            this._cultivosService.updateCultivoCatastro(this.cultivoCatastro).toPromise().finally(() => {
                this._spinnerService.hideSpinner();
            }).then(
                (resp) => {
                    this.newEditForm.disable();
                    this.refresh.emit(true);
                    this.pushMessage.emit('global.success.itemUpdated');
                },
                (error) => {
                  this.showError = true;
                  this.pushMessage.emit('global.error.noResponse');
                }
            );
        }
    }

    public cancel() {
        if (this.cultivoCatastro != null) {
            this.close.emit(true);
            this.refresh.emit(true);
        } else {
            this.editableChanged.emit();
        }
    }

    public closeModal() {
        this.deleteModal = false;
        this._toDelete = '';
    }

    public edit(cultivoCatastro) {
        this.newEditForm.get('poligonoCatastral').enable();
        this.newEditForm.get('parcelaCatastral').enable();
        this.newEditForm.get('refCatastral').enable();
        this.editableChanged.emit(cultivoCatastro);
    }

    public askDelete(cultivoCatastro) {
        this._cultivoId = this.cultivoId;
        this._catastroId = cultivoCatastro.id;
        this.deleteModal = true;
    }

    public delete() {
        this._spinnerService.showSpinner();
        this._cultivosService.deleteCultivoCatastro(this._catastroId).toPromise().finally(() => {
        }).then(() => {
          this.closeModal();
          this.refresh.emit(true);
          this.pushMessage.emit('global.success.itemDeleted');
        });
    }

    private checkForm() {
        this.showError = this.newEditForm.invalid;
        if (this.showError) {
            this.pushMessage.emit('global.error.required');
        }
    }

    public getRolePermission() {
        let disabled = false;

        if (this.role === 'Administrador') {
            disabled = false;
        } else if (this.role === 'Auditor') {
            disabled = false;
        } else if (this.role === 'Supervisor') {
            disabled = true;
        }

        return disabled;
    }
}
